module.exports = __webpack_public_path__ + "static/media/3.b52761ea.jpg";